import React, { useEffect, useState } from 'react'
import RoomView from './RoomView'
import ActionBar from './ActionBar'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { useMemberManager } from "../hooks/useMemberManager";
import MemberView from './MemberView'


export default function Layout() {
    const [isLoading, setIsLoading] = React.useState(true)
    const localMember = useSelector((state: RootState) => state.members.data.find((member) => member.is_local === true))
    const { members } = useMemberManager()
    const Width = window.innerWidth
    const filteredMember = members.slice(Width > 640 ? 9 : 6);
    const [isEndCall, setIsEndCall] = useState(false)

    const videoRef = React.useRef<HTMLVideoElement>(null);

    useEffect(() => {
        if (members[0]?.stream && videoRef.current) {
            videoRef.current!.srcObject = members[0].stream;
        }
        if (members[0]?.is_local && members[0]?.is_video_on === false && videoRef.current) {
            videoRef.current!.srcObject = new MediaStream();
        }
    }, [members, videoRef])

    useEffect(() => {
        if (localMember?.stream) {
            setIsLoading(false)
        }
    }, [localMember])
    return (
        <div className={`  flex flex-col justify-center items-center bg-black`} style={{ height: '100vh', width: '100vw' }}>
            <div className='w-full h-full flex justify-center items-center'>

                {isEndCall ? (<div className='text-white font-semibold text-2xl '>The call has ended</div>)
                    : (isLoading ? <p>Loading media</p> : <RoomView></RoomView>)}
            </div>
            {Width > 640 ?
                members?.length > 9 && (
                    <div className='flex h-1/4 bg-black w-full'>
                        <div className='flex mb-3 lg:h-full w-full justify-center overflow-x-auto' >
                            {filteredMember.map((member: any, index) => (
                                <div className={`${member?.is_local && "hidden"} flex justify-center items-center flex-col hover:bg-zinc-800 lg:w-2/12 flex-shrink-0"`}>
                                    <div key={member.pubkey} className={`h-full w-full  `}>
                                        <MemberView key={member.pubkey} member={member}></MemberView>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='h-full w-1/5'>
                            <video
                                className={`object-cover   h-full w-full relative`}
                                autoPlay={true}
                                controls={true}
                                playsInline={true}
                                muted={true}
                                ref={videoRef}
                            />
                        </div>
                    </div>
                ) : members?.length > 6 && (
                    <div className='flex h-1/5  w-full justify-center overflow-x-auto' >
                        {filteredMember.map((member: any, index) => (
                            <div className={`${member?.is_local && "hidden"}  flex justify-center items-center flex-col hover:bg-zinc-800 flex-shrink-0"`}>
                                <div key={member.pubkey} className={`h-full w-full  `}>
                                    <MemberView key={member.pubkey} member={member}></MemberView>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            {!isEndCall && (
                <div className='bg-transparent flex-none w-full flex items-center justify-around lg:justify-center  bottom-1 '>
                    <ActionBar setIsEndCall={setIsEndCall} />
                </div>
            )}

        </div>
    )
}